export default {
    "headerSpecifiedBlock": "b7b84c950d28bd3c3d46ee725855ad136bf93b39050864d6a7992949d0d44dcd",
    "categories": "9692e844dfb150b4759a4b49286d3023d922ac4a5a2a6156881678269d50df3d",
    "footerMenu": "7e5fd198c478dd5228e48c22b04aac7372d3e2489ededa72aee8bc0a788295a7",
    "topMenu": "1e861fb4cd73b6c0fb8d5a070d4e76804101d9ecd12f7db785a819bd4b13cc43"
};
